import NavItem from "./NavItem";
import { useQuery, useQueryClient } from "react-query";
import React, { useState, useEffect, useRef } from "react";
import Topbarglobal from "./Topbarglobal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Container, Nav, Navbar } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axiosInstance, { baseURL } from "@helper/interceptor";
import { getCustomerBasicInfo } from "@modules/Customer/services/customerCrud";

import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

function AlertDismissibleCustomer() {
  const [show, setShow] = useState(true);
  const { t } = useTranslation();

  if (show) {
    return (
      <Alert className="alert-wrapper" variant="danger" onClose={() => setShow(false)} dismissible>
        <Alert.Heading>{t("demo_project_warning.title")}</Alert.Heading>
        <p>{t("demo_project_warning.description")}</p>
      </Alert>
    );
  }
  return <Button onClick={() => setShow(true)}>Show Alert</Button>;
}

function InfoImageUpload() {
  const [show, setShow] = useState(true);
  const { t } = useTranslation();

  if (show) {
    return (
      <Alert
        className="alert-wrapper-info"
        variant="dark"
        onClose={() => setShow(false)}
        dismissible
      >
        <Alert.Heading>{t("image_upload_info.title")}</Alert.Heading>
        <p>{t("image_upload_info.description")}</p>
      </Alert>
    );
  }
  return <Button onClick={() => setShow(true)}>Show Alert</Button>;
}

function Header() {
  const [customerImage, setCustomerImage] = useState("");
  const [customerName, setCustomerName] = useState("");
  const { mobile } = useSelector((state) => state.mobile);
  // const [paid, setPaid] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // Use customer basic info query
  const {
    data: customerBasicInfo,
    isLoading: isCustomerLoading,
    isError: isCustomerError,
  } = useQuery("customerBasicInfo", getCustomerBasicInfo, {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 30, // 30 minutes
    cacheTime: 1000 * 60 * 60, // 1 hour
    retry: 1,
  });

  // Update local state when background data changes
  useEffect(() => {
    // console.log("Customer data:", { customerBasicInfo, isCustomerLoading, isCustomerError });
    if (customerBasicInfo) {
      // console.log("Setting customer image:", customerBasicInfo.image);
      // Image should now be properly extracted as a string URL
      setCustomerImage(customerBasicInfo.image || "");
      setCustomerName(customerBasicInfo.name || "");
      // setPaid(customerBasicInfo.paid);
    }
  }, [customerBasicInfo, isCustomerLoading, isCustomerError]);

  const logoutInProgress = useRef(false);

  const handleLogout = () => {
    // Prevent multiple logout attempts
    if (logoutInProgress.current) return;
    logoutInProgress.current = true;

    // Completely bypass React/Redux - direct browser-level logout
    const performImmediateLogout = async () => {
      try {
        // Cancel all queries first
        queryClient.cancelQueries();
        queryClient.clear();

        // Clear all storage immediately
        localStorage.clear();
        sessionStorage.clear();

        // Clear cookies
        document.cookie.split(";").forEach((c) => {
          const eqPos = c.indexOf("=");
          const name = eqPos > -1 ? c.substr(0, eqPos) : c;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
          document.cookie =
            name +
            "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" +
            window.location.hostname;
        });

        // Backend logout (non-blocking)
        axiosInstance
          .get(`${baseURL}logout/`, { priority: "high", timeout: 2000 })
          .catch((err) => console.log("Backend logout failed:", err));

        // Force immediate navigation
        window.location.href = "/login";
      } catch (error) {
        console.error("Logout error:", error);
        // Still navigate even if cleanup fails
        window.location.href = "/login";
      }
    };

    // Execute immediately without any delays
    performImmediateLogout();
  };

  return (
    <>
      <header className="header">
        <Navbar bg="primary" variant="dark" expand="lg" className="fixed-top p-0 shadow-sm ">
          <Container>
            <div className="col-md-4 col-sm-3">
              <Nav className="header__start">
                <NavItem mobileView={mobile} handleLogout={handleLogout} />
              </Nav>
            </div>
            <div className="col-md-4 col-sm-6">
              <div className="header__middle">
                <Navbar.Brand aria-label="logo" className="m-0">
                  <img
                    src={process.env.PUBLIC_URL + "/img/treesense-logo.webp"}
                    className="align-middle"
                    height="41"
                    width="90"
                    alt="Treesense Logo"
                  />
                </Navbar.Brand>
                <Navbar.Brand href="/" aria-label="logo-org" className="m-0">
                  <img
                    src={customerImage}
                    className="align-end mt-2"
                    height="35"
                    alt=""
                    onLoad={() => console.log("Customer image loaded:", customerImage)}
                    onError={() => console.log("Customer image failed to load:", customerImage)}
                    style={{ display: customerImage ? "block" : "none" }}
                  />
                </Navbar.Brand>
              </div>
            </div>
            <div className="col-md-4 col-sm-3">
              <div className="header__end">
                <Topbarglobal />
              </div>
            </div>
          </Container>
        </Navbar>
      </header>
      {customerName == "Demo" && <AlertDismissibleCustomer />}
      {/* {customerName != "Demo" && <InfoImageUpload />} */}
    </>
  );
}

export default React.memo(Header);
